import { createAction } from 'redux-actions'
import { get, identity } from 'lodash/fp'
import {
  Action,
  IPaginationReq,
  IPaginationState,
  ThunkAction,
} from '../types/common'
import { query } from '../common/api'
import { USERS_QUERY } from './usersQueries'
import { IUser } from '../types/user'

export const SET_USERS = 'USERS/SET_USERS'
export type SET_USERS = Action<IUser[]>
export const setUsers = createAction<IUser[], IUser[]>(SET_USERS, identity)

export const SET_USERS_PAGINATION_STATE = 'USERS/SET_PAGINATION_STATE'
export type SET_USERS_PAGINATION_STATE = Action<IPaginationState>
export const setPaginationState = createAction<
  IPaginationState,
  IPaginationState
>(SET_USERS_PAGINATION_STATE, identity)

export const SET_USERS_TOTAL = 'USERS/SET_TOTAL'
export type SET_USERS_TOTAL = Action<number>
export const setTotal = createAction<number, number>(SET_USERS_TOTAL, identity)

export interface IUserFilter {
  text?: string
}
export type FilterUsersReq = IPaginationReq & IUserFilter

export const requestUsers =
  (req: FilterUsersReq = {}): ThunkAction<Promise<void>> =>
  async (dispatch) => {
    const response = await query(USERS_QUERY, req)
    const users = get('internal.internals.nodes', response)
    const pageInfo: IPaginationState = get(
      'internal.internals.pageInfo',
      response,
    )
    const total: number = get('internal.internals.totalItems', response)
    dispatch(setPaginationState(pageInfo))
    dispatch(setUsers(users))
    dispatch(setTotal(total))
  }
